import script from "./AlliedProfPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlliedProfPage.vue?vue&type=script&setup=true&lang=ts"

import "./AlliedProfPage.vue?vue&type=style&index=0&id=329ab84a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329ab84a"]])

export default __exports__